import gql from 'graphql-tag'

import { CalloutSchoolListingFieldsFragment } from 'main/components/school/Callout'
import { GatheringFieldsFragment } from 'main/gql/gathering'
import { MapsGeocodeResultFieldsFragment } from 'main/gql/maps'

export const SEARCH_PAGE_QUERY = gql`
  query SearchPage(
    $loadAllCoordinates: Boolean!
    $limit: Int
    $offset: Int
    $location: SchoolListingsLocationInput
    $filters: SchoolListingsFiltersInput
    $rankingFactorWeights: SchoolListingsRankingFactorWeightsInput
  ) {
    result: schoolListings(
      loadAllCoordinates: $loadAllCoordinates
      limit: $limit
      offset: $offset
      location: $location
      filters: $filters
      rankingFactorWeights: $rankingFactorWeights
    ) {
      allCoordinates
      listings {
        ...CalloutSchoolListingFields
        upcomingGatherings {
          ...GatheringFields
        }
      }
      location {
        ...MapsGeocodeResultFields
      }
    }
    user {
      id
    }
  }

  ${CalloutSchoolListingFieldsFragment}
  ${MapsGeocodeResultFieldsFragment}
  ${GatheringFieldsFragment}
`
